import axiosInstance from "../lib/axiosInstance";

const baseUrl = process.env.REACT_APP_API_URL;


const experienceModel = class {

    async listing() {
        const data = await axiosInstance.get(baseUrl + "/admin/experience");
        return data;
    }

    async experienceDetails(id) {
        const data = await axiosInstance.get(baseUrl + "/admin/experience?id=" + id);
        return data;
    }
    async getTrandingCategory() {
        const data = await axiosInstance.get(baseUrl + "/admin/tranding_category");
        return data;
    }

    async experienceDelete(id) {
        const data = await axiosInstance.delete(baseUrl + "/admin/experience/" + id);
        return data;
    }

    async editExperienceDetails(formData = [], id) {
        const data = await axiosInstance.put(baseUrl + "/admin/experience/" + id, formData);
        return data;
    }

    async deleteRatingAndReviews(id) {
        const data = await axiosInstance.delete(baseUrl + "/admin/reviews/" + id);
        return data;
    }

    async ratingDetails(id) {
        const data = await axiosInstance.get(baseUrl + "/admin/reviews?id=" + id);
        return data;
    }


    async experienceReports(id) {
        const data = await axiosInstance.get(baseUrl + "/admin/reports?id=" + id);
        return data;
    }
    async deleteReportData(id) {
        const data = await axiosInstance.delete(baseUrl + "/admin/reports/" + id);
        return data;
    }

}

export default new experienceModel();
